import { useState,useEffect } from 'react';
import Header from '../componenet/Header';
import HeroSection from '../sections/HeroSection';
import MainGuideSection from '../sections/MainGuideSection';
import BonusSection from '../sections/BonusSection';
import MembersSection from '../sections/MembersSection';
import FAQsSection from '../sections/FAQsSection';
import Footer from '../componenet/Footer';
import JoinWaitList from "../componenet/form/JoinWaitList";
import ServicesSection from '../sections/Services';
import AboutUs from '../sections/AboutUs';
import ContactSection from '../sections/ContactSection';
import AOS from 'aos';
const HomePage = () => {
    useEffect(() => {
    AOS.init({
      duration: 1000,
      offset: 100,
      once: true,
    });
  }, []);

    const [showNewPage, setShowNewPage] = useState(false);

    const handleClick =()=>{
      setShowNewPage(true)
    }
    const handleClose=()=>{
      setShowNewPage(false)
    }
  

  return (
    <div>
 {/* JoinWaitList Modal */}
      {showNewPage && (
        <>
          <div className="fixed inset-0 bg-black bg-opacity-80 z-40"></div>
          <div className="fixed inset-0 flex items-center justify-center z-50">
            <div className="relative">
              <JoinWaitList handleClose={handleClose}/>
            </div>
          </div>
        </>
      )}

      {/* Conditionally render Header */}
      {!showNewPage && <Header handleClick={handleClick} />}
      <HeroSection handleClick={handleClick}/>
      <ServicesSection/>
      <AboutUs/>
      <ContactSection/>
      {/* <MainGuideSection/>
      <BonusSection handleClick={handleClick}/>
      <MembersSection handleClick={handleClick}/>
      <FAQsSection/> */}
      <Footer/>
      
    </div>
  )
}

export default HomePage
